/**
 * dev-plugin descriptor — the in-studio development surface, composed into the
 * studio genome via `GenomeBuilderV3.use()`. The canvas is code-split behind
 * `React.lazy` so the dev-plugin chunk (its demo genome, harness, controls) stays
 * out of the app entry payload (gate 8 — wires up with the SPA, #97b); the studio
 * App wraps every routed component in a Suspense boundary.
 *
 * It is itself a `ComposableGenomePlugin`: one `component` editor (`canvas`)
 * routed at `/dev`, contributing into a one-genome-clean genome (gate 4).
 *
 * @module @ubiclouds/v5-genome-dev-plugin/dev-plugin
 */

import { lazy } from 'react';
import { definePlugin } from '@ubiclouds/v5-sdk/plugins';

const LazyDevCanvas = lazy(() => import('./DevCanvas.js'));

export const devPlugin = definePlugin('v5-genome-dev-plugin')
  .name('Dev')
  .trustTier('core')
  .editor('canvas', LazyDevCanvas)
  .route('/dev', { routesTo: 'component/canvas', title: 'Dev' })
  .build();
